import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'

import SearchModal from 'components/SearchModal'
import FormModal from 'components/FormModal'
import FormContainer from './form-container'
import { searchCurriculum } from './actions'

class Curriculums extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openForm: false,
      openSearch: false,
      item: null,
    }
  }

  _openForm = (curriculum) => {
    const item = Map.isMap(curriculum) ? curriculum : null
    this.setState({
      openForm: true,
      item,
    })
  }

  _openSearch = () => {
    this.setState({
      openSearch: true,
    })
  }

  _closeForm = () => {
    this.setState({
      openForm: false,
    })
  }

  _closeSearch = () => {
    this.setState({
      openSearch: false,
    })
  }

  _onSearch = (term) => {
    this.props.dispatch(searchCurriculum(term))
  }

  _onSelectItem = (item) => {
    this._closeSearch()
    this.context.router.push(`/manage/curriculums/${item.get('id')}`)
  }

  _renderForm() {
    const { openForm, item } = this.state

    if (!openForm) {
      return null
    }

    return (
      <FormModal handleClose={this._closeForm}>
        <FormContainer
          item={item}
          close={this._closeForm}
        />
      </FormModal>
    )
  }

  _renderSearch() {
    const { openSearch } = this.state
    const { __list } = this.props

    if (!openSearch) {
      return null
    }

    return (
      <SearchModal
        placeholder="Search Curriculum Name"
        handleClose={this._closeSearch}
        onSubmit={this._onSearch}
        results={__list}
        onSelectItem={this._onSelectItem}
      />
    )
  }

  render() {
    const { children } = this.props

    return (
      <div>
        { React.cloneElement(children, { onCurriculumForm: this._openForm, onSearchForm: this._openSearch }) }
        {this._renderForm()}
        {this._renderSearch()}
      </div>
    )
  }
}

Curriculums.contextTypes = {
  router: PropTypes.object,
}

Curriculums.propTypes = {
  __list: PropTypes.object,
  params: PropTypes.object,
  children: PropTypes.node,
}

function mapStateToProps(state) {
  return {
    __list: state.curriculum.get('list'),
  }
}

export default connect(mapStateToProps)(Curriculums)



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/index.js